module.exports = "<div class=\"widget\" *ngIf=\"!loggedIn\">\r\n    <h1>{{ title }}</h1>\r\n    <p>{{ blurb }}</p>\r\n</div>\r\n"